import { VueQueryPlugin } from '@tanstack/vue-query'
import { OhVueIcon, addIcons } from 'oh-vue-icons'
import { IoCubeOutline } from 'oh-vue-icons/icons'
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import VueApexCharts from 'vue3-apexcharts'

import App from './App.vue'
import router from './router'
import { queryClient } from './lib/vue-query'
import { validateSecurityConfiguration } from './utils/route-security'
import { prelineDirective } from './directives'
import { setPrelineLoaded, initializePreline } from './utils/preline-manager'

import './assets/main.css'

import _ from 'lodash'
import * as VanillaCalendarPro from 'vanilla-calendar-pro'

window._ = _

window.VanillaCalendarPro = VanillaCalendarPro

// Import translations
import en from './locales/en.json'
import ru from './locales/ru.json'
import zh from './locales/zh.json'

// Critical: validate security configuration at startup
const securityValidation = validateSecurityConfiguration()
if (!securityValidation.valid) {
  console.error('CRITICAL: Security configuration errors detected:', securityValidation.errors)
  throw new Error('Application startup failed due to security configuration errors')
}

// Get saved language from localStorage or default to 'en'
const savedLanguage = localStorage.getItem('preferred_language') || 'en'

// Create i18n instance
const i18n = createI18n({
  legacy: false,
  locale: savedLanguage,
  fallbackLocale: 'en',
  messages: {
    en,
    ru,
    zh
  }
})

// Register icons
addIcons(IoCubeOutline)

const app = createApp(App)

const pinia = createPinia()
app.use(pinia)
app.use(router)
app.use(i18n)
app.use(VueQueryPlugin, { queryClient })

// Initialize currency store after Pinia is set up
import { useCurrencyStore } from './stores/currencyStore'
const currencyStore = useCurrencyStore()
currencyStore.initializeFromStorage()

// Note: Validation i18n is initialized in App.vue component

// Register global components
app.component('oh-vue-icon', OhVueIcon)
app.component('apexchart', VueApexCharts)

// Register global directives
app.directive('preline', prelineDirective)

app.mount('#app')

// Debug utilities only available in development mode
// Security tests are handled by the test suite separately

// Import Preline components
import('preline/dist/index.js').then(() => {
  // Set loading status and initialize components
  setPrelineLoaded(true)
  initializePreline()
})
import('@preline/select')
import('@preline/tooltip')
import('@preline/strong-password')
